import { createClient } from "@supabase/supabase-js";
const REACT_APP_SUPABASE_URL = 'https://backend.muffindata.com';
const REACT_APP_SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5naW1mZnNsdWN6aXZwYmZidWdxIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzAzNjU5NzQsImV4cCI6MTk4NTk0MTk3NH0.uEnfu1eocdxkeq2ntezQD1SqWRpB7D_Ns2zthwSV0sw";

export const supabase = createClient(
    REACT_APP_SUPABASE_URL,
    REACT_APP_SUPABASE_KEY
);